customElements.define('product-nav', class productNav extends HTMLElement {
  constructor() {
    super();

    this.stickyNavMenu();
  }

  addClass(entry) { 
    this.querySelectorAll('.product-nav-menu li').forEach(listElement => {
      const dataScrollWithoutDot = listElement.dataset.scroll.replace('.', '');
      if(entry.classList.contains(dataScrollWithoutDot)) {
        listElement.classList.add('active');
      }
    });
  }

  removeClass(entry) { 
    this.querySelectorAll('.sticky-nav-menu li').forEach(listElement => {
      const dataScrollWithoutDot = listElement.dataset.scroll.replace('.', '');
      if(entry.classList.contains(dataScrollWithoutDot)) {
        listElement.classList.remove('active');
      }
    });
  }

  intersectionSetup(elements) { 
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const intersecting = entry.intersecting;
        if(entry.isIntersecting) {
          this.addClass(entry.target);
        } else {
          this.removeClass(entry.target);
        }
      });
    });
    elements.forEach(el => {
      console.log("ELEMENT: ", el);
      if(el !== null && el !== undefined) {
        observer.observe(el)
      }
    });
  }

  stickyNavMenu () {
    const sectionsArray = [];
    this.querySelectorAll('.product-nav-menu li').forEach(listElement => {
      const elementToScrollTo = listElement.dataset.scroll;
      listElement.addEventListener('click', () => {
        document.querySelector(elementToScrollTo).scrollIntoView({
          behavior: 'smooth'
        })
      });
      sectionsArray.push(document.querySelector(elementToScrollTo))
    });
    this.intersectionSetup(sectionsArray);
  }

  connectedCallback() {
    this.elOffsetTop = this.offsetTop

    window.addEventListener('scroll', this.scrollListener.bind(this),);
  }

  scrollListener() {
    if(window.scrollY >= this.elOffsetTop) {
      this.classList.add('product--sticky-form--fixed');
      document.body.style.paddingTop = `${this.offsetHeight}px`;
    } else {
      this.classList.remove('product--sticky-form--fixed');
      document.body.style.paddingTop = `0px`;
    }
  }
});